import { useDataValue, useDataSubmit } from 'Simple/Data.js'

export function useOnChange(props) {
  let referral_templates = useDataValue({
    context: 'referral_templates',
    viewPath: props.viewPath,
  })

  let submit = useDataSubmit({
    context: 'referrals',
    viewPath: props.viewPath,
  })

  let referral_index = useDataValue({
    context: 'referral_item',
    viewPath: props.viewPath,
    path: 'index',
  })

  return function onChange(value) {
    submit({
      type: 'update_referral',
      index: referral_index,
      referral: referral_templates.find(t => t.id === value),
    })
  }
}
